import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#1a0000] py-10 px-4" data-id="element-278">
      <div className="max-w-2xl mx-auto text-center" data-id="element-279">
        <h2 className="text-xl sm:text-2xl font-black text-white mb-4" data-id="element-280">
          ⏰ Precio de lanzamiento termina en:
        </h2>

        <div className="mb-4" data-id="element-281">
          <CountdownTimer size="lg" blinking={true} data-id="element-282" />
        </div>

        <p className="text-white text-sm sm:text-base font-bold mb-6" data-id="element-283">
          Después sube <span className="text-[#FF0000] font-black" data-id="element-284">$8.000</span>{' '}
          y no vuelve a bajar.
        </p>

        <div className="max-w-md mx-auto" data-id="element-285">
          <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden mb-1" data-id="element-286">
            <div className="h-full rounded-full bg-gradient-to-r from-[#FF0000] to-[#FF6600]" style={{
            width: '68%'
          }} data-id="element-287" />
          </div>
          <p className="text-gray-400 text-xs text-right" data-id="element-288">
            🔴 68% de cupos tomados — quedan pocos
          </p>
        </div>
      </div>
    </section>;
}